module.exports = __webpack_public_path__ + "images/category_lp/pc/top_woman_061948732799118269dfa9618f38c007.png";